module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/e420f1d3387b0426a7d0ce0cc831dc26.svg";